SupportBasePresentation = require('./base')
SupportPresenterUtilPresentation = require('./presenter_util')
SupportGetawaysTonightStatusAndNotesPresentation = require('./getaways_tonight_messages')

class SupportGetawaysTonightPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportGetawaysTonightStatusAndNotesPresentation

	getLookupKeySequence: () ->
		keys = []

		if @order?
			keys.push(SupportPresenterUtilPresentation::getStatusKey(@order))
		SupportPresenterUtilPresentation::concatenateLookupKeys(keys)

module.exports = SupportGetawaysTonightPresenterPresentation
